import { phoneFormatter, fallbackPhoneFormatter } from './regexValidators';

const formatPhone = (phone: string): string => {
  const results = phoneFormatter.exec(phone.trim()) || fallbackPhoneFormatter.exec(phone.trim());
  
  if (results !== null && results.length > 6) {
    return `${typeof results[1] !== 'undefined' ? `+${results[1]}` : ''} (${results[3]}) ${results[4]}-${results[5]} ${typeof results[8] !== 'undefined' ? ` x${results[8]}` : results[6] !== undefined ? ` x${results[6]}` : ''}`;
  }
  return phone;
};

export { formatPhone };
